

import { computed, ref } from 'vue'
import AuthRepository from '@/services/AuthRepository'
import { useToast } from "primevue/usetoast";
import { useRouter } from 'vue-router'
import {Register} from "../models/register";
import {useStore} from "vuex";
import {RegisterUser} from "@/models/registerUser";
import {AccountPermission} from "@/models/accountPermission";
import {DichVuCreate} from "@/models/dichVuCreate";
import {DichVu} from "@/models/dichVu";
import moment from 'moment';
import {FilterMatchMode} from "primevue/api";
import {LieuTrinhCreate} from "@/models/lieuTrinhCreate";
import {LieuTrinh} from "@/models/lieuTrinh";
import {SanPhamCreate} from "@/models/sanPhamCreate";
import {SanPham} from "@/models/sanPham";
import {DichVuUpdate} from "@/models/dichVuUpdate";
import {LieuTrinhUpdate} from "@/models/lieuTrinhUpdate";
import {SanPhamUpdate} from "@/models/sanPhamUpdate";
import router from "@/router";

export default {

  setup(){
    const router = useRouter();
    const dichVuCreate = ref({} as DichVuCreate);
    const listDichVu = ref([] as DichVu[]);
    const lieuTrinhCreate = ref({} as LieuTrinhCreate);
    const listLieuTrinh = ref([] as LieuTrinh[]);
    const sanPhamCreate = ref({} as SanPhamCreate);
    const listSanPham= ref([] as SanPham[]);
    const toast = useToast();
    const store = useStore();
    const error = ref(null);
    const dichVuUpdate = ref({} as DichVuUpdate);
    const sanPhamUpdate = ref({} as SanPhamUpdate);
    const lieuTrinhUpdate = ref({} as LieuTrinhUpdate);
    if (!!!store.state.token) {
      router.push({ name: "home" });
    }

    if(!(store.state.permission == 'admin')){
      router.push({
        name: 'home'
      });
    }
    dichVuCreate.value.giamGia = 0;
    sanPhamCreate.value.giamGia = 0;
    lieuTrinhCreate.value.giamGia = 0;


    const validDichVu = computed(()=>  dichVuCreate.value.tenDichVu && dichVuCreate.value.giaBan  && dichVuCreate.value.giamGia != null && dichVuCreate.value.giaThucThu );
    const validDichVuUpdate = computed(()=>  dichVuUpdate.value.tenDichVu && dichVuUpdate.value.giaBan  && dichVuUpdate.value.giamGia != null && dichVuUpdate.value.giaThucThu );

    const inputGiamGiaDV = ()=> {
      console.log("######################### inputGiamGiaDV");
      console.log("######################### inputGiamGiaDV dichVuCreate: " + JSON.stringify(dichVuCreate.value));
      if(dichVuCreate.value.giaBan > 0)
      {
        if(dichVuCreate.value.giamGia > 0)
        {
          dichVuCreate.value.giaThucThu = dichVuCreate.value.giaBan - (dichVuCreate.value.giaBan * dichVuCreate.value.giamGia)/100;
        }
        else
          dichVuCreate.value.giaThucThu = dichVuCreate.value.giaBan;
      }
      else
      {

      }
    };

    const inputGiamGiaDVUpdate = ()=> {
      console.log("######################### inputGiamGiaDVUpdate");
      console.log("######################### inputGiamGiaDVUpdate dichVuUpdate: " + JSON.stringify(dichVuUpdate.value));
      if(dichVuUpdate.value.giaBan > 0)
      {
        if(dichVuUpdate.value.giamGia > 0)
        {
          dichVuUpdate.value.giaThucThu = dichVuUpdate.value.giaBan - (dichVuUpdate.value.giaBan * dichVuUpdate.value.giamGia)/100;
        }
        else
          dichVuUpdate.value.giaThucThu = dichVuUpdate.value.giaBan;
      }
      else
      {

      }
    };

    const getListDichVu = () => {
      AuthRepository.getListDichVuAll()
          .then((response) => {
            listDichVu.value = response.data;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }
    getListDichVu();

    const createDichVu = () => {
      console.log("######################### createDichVu");
      console.log("######################### createDichVu dichVuCreate: " + JSON.stringify(dichVuCreate.value));
        AuthRepository.createDichVu(dichVuCreate.value)
          .then((response) => {
            toast.add({
              severity: 'success',
              summary: 'Thành công',
              detail: 'Thêm dịch vụ thành công',
              life: 2000
            });
            getListDichVu();
            const temp = ref({} as DichVuCreate);
            dichVuCreate.value = temp.value;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }

    const getListLieuTrinh= () => {
      AuthRepository.getListLieuTrinhAll()
          .then((response) => {
            listLieuTrinh.value = response.data;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }
    getListLieuTrinh();

    const createLieuTrinh = () => {
      console.log("######################### createLieuTrinh");
      console.log("######################### createLieuTrinh lieuTrinhCreate: " + JSON.stringify(lieuTrinhCreate.value));
      AuthRepository.createLieuTrinh(lieuTrinhCreate.value)
          .then((response) => {
            toast.add({
              severity: 'success',
              summary: 'Thành công',
              detail: 'Thêm liệu trình thành công',
              life: 2000
            });
            getListLieuTrinh();
            const temp = ref({} as LieuTrinhCreate);
            lieuTrinhCreate.value = temp.value;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }

    const validLieuTrinh = computed(()=>  lieuTrinhCreate.value.tenLieuTrinh && lieuTrinhCreate.value.soLanThucHien  && lieuTrinhCreate.value.giaNhap
        && lieuTrinhCreate.value.giaBan && lieuTrinhCreate.value.giamGia!=null && lieuTrinhCreate.value.giaThucThu && lieuTrinhCreate.value.khoangCachDieuTri!=null );
    const validLieuTrinhUpdate = computed(()=>  lieuTrinhUpdate.value.tenLieuTrinh && lieuTrinhUpdate.value.soLanThucHien  && lieuTrinhUpdate.value.giaNhap
        && lieuTrinhUpdate.value.giaBan && lieuTrinhUpdate.value.giamGia!=null && lieuTrinhUpdate.value.giaThucThu && lieuTrinhUpdate.value.khoangCachDieuTri!=null );


    const inputGiamGiaLieuTrinh= ()=> {
      console.log("######################### inputGiamGiaLieuTrinh");
      console.log("######################### inputGiamGiaLieuTrinh lieuTrinhCreate: " + JSON.stringify(lieuTrinhCreate.value));
      if(lieuTrinhCreate.value.giaBan > 0)
      {
        if(lieuTrinhCreate.value.giamGia > 0)
        {
          lieuTrinhCreate.value.giaThucThu = lieuTrinhCreate.value.giaBan - (lieuTrinhCreate.value.giaBan * lieuTrinhCreate.value.giamGia)/100;
        }
        else
          lieuTrinhCreate.value.giaThucThu = lieuTrinhCreate.value.giaBan;
      }
      else
      {

      }
    };

    const inputGiamGiaLieuTrinhUpdate= ()=> {
      console.log("######################### inputGiamGiaLieuTrinhUpdate");
      console.log("######################### inputGiamGiaLieuTrinhUpdate lieuTrinhUpdate: " + JSON.stringify(lieuTrinhUpdate.value));
      if(lieuTrinhUpdate.value.giaBan > 0)
      {
        if(lieuTrinhUpdate.value.giamGia > 0)
        {
          lieuTrinhUpdate.value.giaThucThu = lieuTrinhUpdate.value.giaBan - (lieuTrinhUpdate.value.giaBan * lieuTrinhUpdate.value.giamGia)/100;
        }
        else
          lieuTrinhUpdate.value.giaThucThu = lieuTrinhUpdate.value.giaBan;
      }
      else
      {

      }
    };

    const getListSanPham = () => {
      AuthRepository.getListSanPhamAll()
          .then((response) => {
            listSanPham.value = response.data;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }
    getListSanPham();

    const createSanPham = () => {
      console.log("######################### createSanPham");
      console.log("######################### createSanPham createSanPham: " + JSON.stringify(sanPhamCreate.value));
      AuthRepository.createSanPham(sanPhamCreate.value)
          .then((response) => {
            toast.add({
              severity: 'success',
              summary: 'Thành công',
              detail: 'Thêm sản phẩm thành công',
              life: 2000
            });
            getListSanPham();
            const temp = ref({} as SanPhamCreate);
            sanPhamCreate.value = temp.value;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }

    const validSanPham = computed(()=>  sanPhamCreate.value.tenSanPham && sanPhamCreate.value.giaNhap && sanPhamCreate.value.giaBan
        && sanPhamCreate.value.giamGia != null && sanPhamCreate.value.giaThucThu && sanPhamCreate.value.soLuongNhap );
    const validSanPhamUpdate = computed(()=>  sanPhamUpdate.value.tenSanPham && sanPhamUpdate.value.giaNhap && sanPhamUpdate.value.giaBan
        && sanPhamUpdate.value.giamGia != null && sanPhamUpdate.value.giaThucThu && sanPhamUpdate.value.soLuongNhap );

    const inputGiamGiaSanPham = ()=> {
      console.log("######################### inputGiamGiaSanPham");
      console.log("######################### inputGiamGiaSanPham sanPhamCreate: " + JSON.stringify(sanPhamCreate.value));
      if(sanPhamCreate.value.giaBan > 0)
      {
        if(sanPhamCreate.value.giamGia > 0)
        {
          sanPhamCreate.value.giaThucThu = sanPhamCreate.value.giaBan - (sanPhamCreate.value.giaBan * sanPhamCreate.value.giamGia)/100;
        }
        else
          sanPhamCreate.value.giaThucThu = sanPhamCreate.value.giaBan;
      }
      else
      {

      }
    };

    const inputGiamGiaSanPhamUpdate = ()=> {
      console.log("######################### inputGiamGiaSanPhamUpdate");
      console.log("######################### inputGiamGiaSanPhamUpdate sanPhamUpdate: " + JSON.stringify(sanPhamUpdate.value));
      if(sanPhamUpdate.value.giaBan > 0)
      {
        if(sanPhamUpdate.value.giamGia > 0)
        {
          sanPhamUpdate.value.giaThucThu = sanPhamUpdate.value.giaBan - (sanPhamUpdate.value.giaBan * sanPhamUpdate.value.giamGia)/100;
        }
        else
          sanPhamUpdate.value.giaThucThu = sanPhamUpdate.value.giaBan;
      }
      else
      {

      }
    };

    const formatDateTime = (date) => {
      if((date == null)||(date == ''))
      {
        return ""
      }
      else
        return moment(String(date)).format(' DD/MM/YYYY');
    };
    const filters = ref({
      'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
    });

    const clearFilter = () => {
      initFilters();
    };

    const initFilters = () => {
      filters.value = {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      }
    };

    const formatCurrency = (money) => {
      // Use Intl.NumberFormat to format the number as currency
      const formatter = new Intl.NumberFormat('vi-VN', {
        style: 'currency',
        currency: 'VND',
        minimumFractionDigits: 0, // Set the number of decimal places you want
      });
      return formatter.format(money);
    };
    const validUpdate = ref(false);

    const clickUpdateDichVu = (id) => {
      listDichVu.value.forEach(x => {
        if(x.id == id){
          dichVuUpdate.value.id = x.id;
          dichVuUpdate.value.tenDichVu = x.tenDichVu;
          dichVuUpdate.value.giaNhap = x.giaNhap;
          dichVuUpdate.value.giaBan = x.giaBan;
          dichVuUpdate.value.giamGia = x.giamGia;
          dichVuUpdate.value.giaThucThu = x.giaThucThu;
          dichVuUpdate.value.tamNgung = x.tamNgung;
          validUpdate.value = true;
        }
      })
    }

    const soLuongDaBan = ref(0);
    const clickUpdateSanPham = (id) => {
      listSanPham.value.forEach(x => {
        if(x.id == id){
          sanPhamUpdate.value.id = x.id;
          sanPhamUpdate.value.tenSanPham = x.tenSanPham;
          sanPhamUpdate.value.giaNhap = x.giaNhap;
          sanPhamUpdate.value.giaBan = x.giaBan;
          sanPhamUpdate.value.giamGia = x.giamGia;
          sanPhamUpdate.value.giaThucThu = x.giaThucThu;
          sanPhamUpdate.value.tamNgung = x.tamNgung;
          sanPhamUpdate.value.soLuongNhap = x.soLuongNhap;
          soLuongDaBan.value = x.soLuongDaBan;
          validUpdate.value = true;
        }
      })
    }

    const clickUpdateLieuTrinh = (id) => {
      listLieuTrinh.value.forEach(x => {
        if(x.id == id){
          lieuTrinhUpdate.value.id = x.id;
          lieuTrinhUpdate.value.tenLieuTrinh = x.tenLieuTrinh;
          lieuTrinhUpdate.value.giaNhap = x.giaNhap;
          lieuTrinhUpdate.value.giaBan = x.giaBan;
          lieuTrinhUpdate.value.giamGia = x.giamGia;
          lieuTrinhUpdate.value.giaThucThu = x.giaThucThu;
          lieuTrinhUpdate.value.soLanThucHien = x.soLanThucHien;
          lieuTrinhUpdate.value.khoangCachDieuTri = x.khoangCachDieuTri;
          lieuTrinhUpdate.value.tamNgung = x.tamNgung;
          validUpdate.value = true;

        }
      })
    }

    const updateDichVu = () => {
      console.log("######################### updateDichVu");
      console.log("######################### updateDichVu dichVuUpdate: " + JSON.stringify(dichVuUpdate.value));
      AuthRepository.updateDichVu(dichVuUpdate.value)
          .then((response) => {
            toast.add({
              severity: 'success',
              summary: 'Thành công',
              detail: 'Cập nhật dịch vụ thành công',
              life: 2000
            });
            getListDichVu();
            const temp = ref({} as DichVuUpdate);
            dichVuUpdate.value = temp.value;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }

    const updateLieuTrinh = () => {
      console.log("######################### updateLieuTrinh");
      console.log("######################### updateLieuTrinh lieuTrinhUpdate: " + JSON.stringify(lieuTrinhUpdate.value));
      AuthRepository.updateLieuTrinh(lieuTrinhUpdate.value)
          .then((response) => {
            toast.add({
              severity: 'success',
              summary: 'Thành công',
              detail: 'Cập nhật liệu trình thành công',
              life: 2000
            });
            getListLieuTrinh();
            const temp = ref({} as LieuTrinhUpdate);
            lieuTrinhUpdate.value = temp.value;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }

    const updateSanPham = () => {
      console.log("######################### updateSanPham");
      console.log("######################### updateSanPham sanPhamUpdate: " + JSON.stringify(sanPhamUpdate.value));
      if(soLuongDaBan.value > sanPhamUpdate.value.soLuongNhap){
        toast.add({
          severity: 'error',
          summary: 'Lỗi',
          detail:'Số lượng nhập đang thấp hơn số lượng đã bán, vui lòng kiểm tra lại',
          life: 3000
        });
      }
      else {
        AuthRepository.updateSanPham(sanPhamUpdate.value)
            .then((response) => {
              toast.add({
                severity: 'success',
                summary: 'Thành công',
                detail: 'Cập nhật sản phẩm thành công',
                life: 2000
              });
              getListSanPham();
              const temp = ref({} as SanPhamUpdate);
              sanPhamUpdate.value = temp.value;
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail: err.response.data,
                life: 2000
              });
            });
      }
    }

    const onDialogClose = () => {
      //console.log('Dialog đã đóng')
      validUpdate.value = false;
      const lieuTrinhTemp = ref({} as LieuTrinhUpdate);
      lieuTrinhUpdate.value = lieuTrinhTemp.value;
      const sanPhamTemp = ref({} as SanPhamUpdate);
      sanPhamUpdate.value = sanPhamTemp.value;
      const dichVuTemp = ref({} as DichVuUpdate);
      dichVuUpdate.value = dichVuTemp.value;
      // validUpdate.value = false;
      // reset form
      // clear data
    }

    const hasUpdateData = computed(() =>
        dichVuUpdate.value.id > 0 ||
        sanPhamUpdate.value.id > 0 ||
        lieuTrinhUpdate.value.id > 0
    )

    return {
      onDialogClose,
      error,
      inputGiamGiaDV,
      dichVuCreate,
      validDichVu,
      createDichVu,
      listDichVu,
      inputGiamGiaLieuTrinh,
      inputGiamGiaLieuTrinhUpdate,
      lieuTrinhCreate,
      validLieuTrinh,
      createLieuTrinh,
      listLieuTrinh,
      sanPhamCreate,
      validSanPham,
      createSanPham,
      listSanPham,
      inputGiamGiaSanPham,
      inputGiamGiaSanPhamUpdate,
      formatDateTime,
      filters,
      clearFilter,
      initFilters,
      formatCurrency,
      // donVi,
      dichVuUpdate,
      sanPhamUpdate,
      lieuTrinhUpdate,
      clickUpdateDichVu,
      clickUpdateLieuTrinh,
      clickUpdateSanPham,
      updateDichVu,
      updateSanPham,
      updateLieuTrinh,
      inputGiamGiaDVUpdate,
      validDichVuUpdate,
      validLieuTrinhUpdate,
      validSanPhamUpdate,
      validUpdate,
      hasUpdateData,
    }
  }
}

